import getConfig from 'next/config';
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages

const { publicRuntimeConfig } = getConfig();
const GA_TRACKING_ID = publicRuntimeConfig.gaTrackingID;

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: string) => {
  // eslint-disable-next-line
  // @ts-ignore
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({
  action,
  category,
  label,
  value,
}: {
  action: string;
  category: string;
  label: string;
  value?: any;
}) => {
  // eslint-disable-next-line
  // @ts-ignore
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
};
